import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.searchBar || initialState;

export const selectSearchBar = createSelector(
  [selectSlice],
  state => state,
);
